import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { bpmnPageServeDetailProcess, bpmnPageDeptStastic, bpmnPageServeStastic } from "@/api/bpmnApi/bpmn";
export default {
  name: "detailShowTwo",
  data: function data() {
    return {
      show: false,
      loading: false,
      title: "",
      list: [],
      total: 0,
      pageSizes: [10, 20, 30, 50, 100],
      paramSearch: {
        current: 1,
        size: 10
      },
      time: {
        beginTime: "",
        endTime: "",
        processDefId: "",
        deptId: ""
      },
      curTab: ""
    };
  },
  computed: {},
  methods: {
    bpmnPageServeDetailProcessFn: function bpmnPageServeDetailProcessFn() {
      var _this = this;

      var params = _objectSpread(_objectSpread({}, this.time), this.paramSearch);

      var method;

      if (this.curTab == "serve") {
        delete params.deptId;
        method = bpmnPageServeDetailProcess;
      }

      if (this.curTab == "dept") {
        delete params.processDefId;
        method = bpmnPageServeStastic;
      }

      this.loading = true;
      method(params).then(function (_ref) {
        var data = _ref.data;
        _this.loading = false;

        if (data.code == 0) {
          _this.list = data.data.records || [];
          _this.total = data.data.total;
        }
      }).catch(function (err) {
        _this.loading = false;
      });
    },
    // 条数
    changeSize: function changeSize(value) {
      this.paramSearch.size = value;
      this.paramSearch.current = 1;
      this.bpmnPageServeDetailProcessFn();
    },
    // 翻页
    changePage: function changePage(value) {
      this.paramSearch.current = value;
      this.bpmnPageServeDetailProcessFn();
    },
    // 显示弹框
    dialogShow: function dialogShow(item, params, curTab) {
      this.paramSearch = {
        current: 1,
        size: 10
      };
      this.show = true; // 显示弹框

      this.curTab = curTab;
      this.time.beginTime = params.beginTime;
      this.time.endTime = params.endTime;

      if (curTab == "serve") {
        this.time.processDefId = item.processDefId;
        this.title = "【" + item.serveName + "】 服务效能详情";
      }

      if (curTab == "dept") {
        this.time.deptId = item.deptId;
        this.title = "【" + item.deptName + "】 效能详情";
      }

      this.bpmnPageServeDetailProcessFn();
    }
  },
  watch: {
    show: function show(flag) {
      if (!flag) {
        this.list = [];
      }
    }
  },
  filters: {}
};